__turbopack_context__.v({
  "block": "AsFGtq_block",
  "form": "AsFGtq_form",
  "infoErrorContainer": "AsFGtq_infoErrorContainer",
  "inputRows": "AsFGtq_inputRows",
  "isSuccess": "AsFGtq_isSuccess",
  "lableTitle": "AsFGtq_lableTitle",
  "root": "AsFGtq_root",
  "selectWrapper": "AsFGtq_selectWrapper",
  "submit": "AsFGtq_submit",
  "successBlock": "AsFGtq_successBlock",
  "textDescription": "AsFGtq_textDescription",
});
